import * as React from 'react';
import { HeartFavoriteButton } from '../../components/Favorite/HeartFavoriteButton';
import { TopControls } from '../../components/TopControls';
import { FavoriteContainer } from '../Favorite';
import { FullscreenGalleryContainer } from '../FullscreenGallery';

export function TopControlsContainer() {
  return (
    <TopControls
      gallery={<FullscreenGalleryContainer />}
      favorite={<FavoriteContainer button={HeartFavoriteButton} />}
    />
  );
}
